import React from 'react';
import ReactDOM from 'react-dom/client';
import Home from './pages/Home.js';
import "./assets/css/common.css";
import './assets/css/index.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import AboutUs from './pages/AboutUs.js';
import Research from './pages/Research.js';
import Contact from './pages/Contact.js';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
    </Router>
  </React.StrictMode>
);